import React from 'react'
import styled from 'styled-components'
import { TwitterCircleFilled, FacebookFilled } from '@ant-design/icons'
import riseIcon from './cnr_icon.svg'
import swapIcon from './cns_icon.svg'
import bnbIcon from './bnb_icon.svg'
import centricLogo from './centric_logo.png'
import centricLogoFull from './centric_logo_white.svg'
import centricExplorerLogo from './centric_explorer_logo.png'
import centricBscIcon from './cen_bsc_logo.png'
import discord from './discord_logo.png'
import telegram from './telegram_logo.png'
import centricIcon from './centric_icon.png'

const IconImg = styled.img`
  width: ${(props) => (props.width ? props.width : 'auto')};
`

interface Props {
  icon: string
  width?: string
}

export default function ShowIcon({ icon, width }: Props) {
  switch (icon) {
    case 'rise':
      return <IconImg width={width ?? '24px'} src={riseIcon} alt="" />
    case 'swap':
      return <IconImg width={width ?? '24px'} src={swapIcon} alt="" />
    case 'centric':
      return <IconImg width={width ?? '24px'} src={centricIcon} alt="" />
    case 'tron':
      return <IconImg width={width ?? '24px'} src={bnbIcon} alt="" />
    case 'logo_text':
      return <IconImg src={centricLogo} alt="Centric Explorer" />
    case 'logo_full':
      return <IconImg src={centricLogoFull} alt="Centric" />
    case 'logo_explorer':
      return (
        <>
          <IconImg src={centricBscIcon} width="60px" style={{ marginRight: 6 }} alt="Centric BSC Explorer" />
          <IconImg src={centricExplorerLogo} style={{ maxWidth: 90 }} alt="Centric Logo" />
        </>
      )
    case 'twitter':
      return <TwitterCircleFilled style={{ width: 30, marginRight: '0.5rem' }} />
    case 'facebook':
      return <FacebookFilled style={{ width: 30, marginRight: '0.5rem' }} />
    case 'telegram':
      return <IconImg width="22px" src={telegram} alt="Telegram" />
    case 'discord':
      return <IconImg src={discord} alt="Discord" />
    default:
      return <img alt="" />
  }
}
